import { assertNotEmpty } from '@festina-life/core'

import type {
  FPlusExpressionValue,
  SubTemplateFieldValue,
  SubTemplateValueSetupFieldValue,
} from '../../../types/templateModel'
import { generateEmptyAttributeExpressionValue } from '../../../uiModels/createEmptyFieldHelpers'

export const updateVariant = ({
  variant,
  property,
  value,
}: {
  variant: SubTemplateFieldValue
  property: 'defaultSelected' | 'selectable'
  value: FPlusExpressionValue
}) => {
  const { subTemplatedField } = variant
  assertNotEmpty(subTemplatedField?.value)

  const nextVariants = [...subTemplatedField.value.variants]
  const changedVariantPosition = nextVariants.findIndex(
    (v) => v.subTemplateIdentifier === variant.subTemplateIdentifier,
  )

  const propertyValues =
    variant[property] ??
    generateEmptyAttributeExpressionValue({
      path: variant.path,
      fieldName: property,
    })
  const copiedVariant = { ...variant }
  delete copiedVariant[property]

  const nextVariant: SubTemplateFieldValue = {
    ...copiedVariant,
    origin: copiedVariant.path,
    ...(value.fplusSource
      ? {
          [property]: {
            ...propertyValues,
            expression: value,
            origin: propertyValues.path,
          },
        }
      : {}),
  }
  nextVariants.splice(changedVariantPosition, 1, nextVariant)

  return (
    subTemplatedField.update as (
      value: SubTemplateValueSetupFieldValue,
    ) => Promise<void>
  )({
    ...subTemplatedField.value,
    variants: nextVariants,
  })
}
